import { Routes, Route, Navigate } from 'react-router-dom'
import { Frame } from '@shopify/polaris'
import DraftOrdersList from './pages/DraftOrdersList'
import DraftOrderDetail from './pages/DraftOrderDetail'
import CreateDraftOrder from './pages/CreateDraftOrder'
import Settings from './pages/Settings'
import AppVersionBadge from './components/AppVersionBadge'

export default function App() {
    return (
        <Frame>
            <Routes>
                <Route path="/" element={<DraftOrdersList />} />
                <Route path="/draft-orders" element={<Navigate to="/" replace />} />
                <Route path="/draft-orders/:id" element={<DraftOrderDetail />} />
                <Route path="/create" element={<CreateDraftOrder />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <AppVersionBadge />
        </Frame>
    )
}
